import { useState } from "react";
import ModalBox from "./ModalBox";
import { Button, Col, Input, Row, Spinner } from "reactstrap";
import emojis from "../data/emoji";
import LogoModalHeader from "./LogoModalHeader";
import { useAuth } from "./AuthProvider";
import { updateProfile } from "../service/auth";

function ChangeEmojiModal({ isOpen, onClose }) {
  const { authDetails, navigateStage } = useAuth();
  const [selectedEmoji, setSelectedEmoji] = useState(authDetails?.emoji || emojis[0].name);
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  function handleSelectEmoji(event) {
    const emoji = event.target.value;
    setSelectedEmoji(emoji);
  }

  function handleSubmit(event) {
    event.preventDefault();
    if (selectedEmoji) {
      setError("");
      setIsLoading(true);
      updateProfile({ emoji: selectedEmoji })
        .then(() => {
          const authUser = JSON.parse(
            localStorage.getItem("authUser") || "null"
          );
          authUser.emoji = selectedEmoji;
          localStorage.setItem("authUser", JSON.stringify(authUser));
          navigateStage({ emoji: selectedEmoji });
          onClose();
        })
        .catch((error) => {
          setError("Failed to update emoji. Please try again.");
          console.error("Error updating emoji:", error);
        })
        .finally(() => setIsLoading(false));
    }
  }

  return (
    <ModalBox open={isOpen} onClose={onClose} showCloseButton={true}>
      <form onSubmit={handleSubmit} className="auth-modal-wrapper">
        <LogoModalHeader />
        <label>Choose a new emoji for your profile</label>
        <Row className="g-2">
          {emojis.map((emoji) => (
            <Col xs="3" key={emoji.name} className="text-center">
              <label
                className={`emoji-box ${
                  selectedEmoji === emoji.name ? "selected" : ""
                }`}
              >
                <img src={emoji.src} alt={emoji.name} />
                <Input
                  type="radio"
                  name="emoji"
                  value={emoji.name}
                  onChange={handleSelectEmoji}
                  hidden
                />
              </label>
            </Col>
          ))}
          <p className="input-error col-12">{error}</p>
        </Row>
        <Button
          type="submit"
          color="primary"
          block
          disabled={!selectedEmoji || isLoading}
        >
          {isLoading ? <Spinner size="sm" /> : "Update Emoji"}
        </Button>
      </form>
    </ModalBox>
  );
}

export default ChangeEmojiModal;
